import React from "react";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
const sucIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9 11L12 14L22 4M16 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RHToast = () => {
  return (
    <div>
      <Toaster
        reverseOrder={false}
        position="top-center"
        gutter={6}
        toastOptions={{
          style: {
            borderRadius: "4px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            maxWidth: "450px",
            paddingTop: "10px",
          },
          error: {
            style: {
              color: "#FF2626",
              border: "1px solid #FF2626",
              background: "#FFF3F1",
            },
            icon: <HighlightOffIcon style={{ fontSize: "20px" }} />,
          },
          success: {
            style: {
              background: "linear-gradient(90deg, #78768C 54.4%, #5D5C68 100%)",
            },
            icon: sucIcon,
          },
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {(props) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ paddingTop: "1px" }}>{props.icon}</div>
                  <div style={{}}>{props.message}</div>
                </div>
              );
            }}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
};

export default RHToast;
